module.exports = __webpack_public_path__ + "img/96sdriver.e2e684f8.webp";